if (!customElements.get('language-toggle')) {
  customElements.define(
    'language-toggle',
    class LanguageToggle extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.currentLocale = this.dataset.currentLocale || '';
        if (!this.currentLocale) {
          const active = this.querySelector('.language-toggle__option--active');
          this.currentLocale = active ? active.value : '';
        }

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        const submitter =
          event.submitter ||
          (event.target && event.target.querySelector && this.form.querySelector('button:focus')) ||
          document.activeElement;

        if (!submitter || submitter.name !== 'locale_code') return;

        // Avoid a no-op reload when the already-active language is clicked.
        if (submitter.value && submitter.value === this.currentLocale) {
          event.preventDefault();
        }
      }
    }
  );
}
